<template>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="CompanyInfo">
        <el-tab-pane label="我的公司" name="first">

            <div style="padding:5px 5px 5px 5px">
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>公司列表</b></p>
                    <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                        <el-button round type="primary" @click="openDrawer">创建公司</el-button>
                    </p>
                </div>
            </div>

            <el-row>
                <el-drawer title="创建自己的公司" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
                    style="text-align: left;">
                    <p style="padding:0 0 0 10px">公司名称</p>
                    <el-input placeholder="请输入" v-model="companyName" clearable style="width:350px;margin: 0 0 0 10px;">
                    </el-input>

                    <div id="cancel_determine">
                        <el-button round @click="drawer = false">取消</el-button>
                        <el-button round type="primary" @click="createCompany">确认</el-button>
                    </div>
                </el-drawer>
            </el-row>

            <template>
                <el-table :data="companyList" style="width: 100%" max-height="500">
                    <el-table-column fixed prop="companyName" label="公司名称" min-width="45%">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="expireTime" label="有效期" min-width="15%">
                        <template slot-scope="scope">
                            <el-tag size='mini' v-if="scope.row.etTag" type="danger">已过期</el-tag>
                            <span>{{ scope.row.expireTime }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="createdTime" label="创建时间" min-width="15%">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" min-width="15%">
                        <template slot-scope="scope">
                            <el-button @click="editClick(scope.row)" type="success" round size="small">
                                编辑
                            </el-button>
                            <el-button @click="switchClick(scope.row)" type="success" round size="small"
                                v-if="scope.row.id != companyId">
                                {{ scope.row.id == companyId ? '' : '切换' }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </el-tab-pane>

        <el-tab-pane label="转让公司" name="third">
            <el-select v-model="maker" placeholder="选择新的公司所有者" style="width:220px">
                <el-option v-for="item in empList" :key="item.value" :label="item.employeeName" :value="item.userId">
                </el-option>
            </el-select>

            <el-button type="success" plain round @click="confirmTransCompany">确定转让</el-button>
        </el-tab-pane>

        <el-tab-pane label="注销公司" name="fourth">
            <p style="font-size:large;color:green">
                <b>如果你的公司决定不再使用注塑+，可以选择注销当前公司，注销后公司所有数据都将删除，并且<span style="color:yellowgreen">无法恢复</span>，请谨慎操作！！</b>
            </p>
            <el-button type="success" plain round @click="cancelCompany">确定注销</el-button>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import router from '../../router';

export default {
    name: "CompanyInfo",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            activeName: 'first',
            drawer: false,
            direction: 'rtl',
            id: '',
            companyName: '',
            companyList: [],

            empList: [],
            maker: '',

            opUrl: ''
        };
    },
    methods: {
        handleClick(tab, event) {
            //console.log(tab, event)

            if (tab.index == '1') {

                this.getAllEmp()
            }
        },
        handleClose(done) {
            done()
        },
        openDrawer() {
            this.id = ''
            this.companyName = ''
            this.drawer = true

            this.opUrl = 'company/add'
        },
        editClick(row) {
            this.opUrl = 'company/edit'

            this.id = row.id
            this.companyName = row.companyName
            this.drawer = true
        },
        switchClick(row) {

            this.$axios({
                method: "put",
                url: "/shiro/sys/token/modify",
                data: {
                    companyId: row.id,
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.data != null) {
                    
                    this.setToken(data.data)
                }

                this.setCompanyId(row.id)

                location.reload()
            })
        },
        createCompany() {
            this.$axios({
                method: "post",
                url: "/shiro/" + this.opUrl,
                data: {
                    id: this.id,
                    companyName: this.companyName,
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)
                this.drawer = false
                this.getAllCompany()
            })
        },
        getAllEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.empList = data.data
            })
        },
        confirmTransCompany() {
            this.$confirm('确定要转让公司吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.transferCompany()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        transferCompany() {
            this.$axios({
                method: "post",
                url: "/shiro/company/transfer",
                data: {
                    id: this.companyId,
                    userId: this.maker
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: data.msg
                    })

                } else {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

            })
        },
        cancelCompany() {
            this.$confirm('确定要执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeCompany()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                })
            })
        },
        removeCompany() {
            this.$axios({
                method: "delete",
                url: "/shiro/company/cancel",
                data: {
                    id: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: data.msg
                    })

                    this.$router.push({
                        path: "/Company"
                    })

                } else {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

            })
        },
        getAllCompany() {
            this.$axios({
                method: "post",
                url: "/shiro/company/getAll",
                data: {
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //console.log(result.data)
                this.companyList = result.data.data

                for (let key in this.companyList) {
                    //console.log(this.companyList[key].createdTime)
                    var etStr = this.$moment(this.companyList[key].expireTime).format("YYYY-MM-DD HH:mm")
                    var et = new Date(etStr)

                    if (et < new Date()) {
                        this.companyList[key].etTag = true
                        this.companyList[key].expireTime = ''
                    } else {
                        this.companyList[key].expireTime = etStr
                    }

                    this.companyList[key].createdTime = this.$moment(this.companyList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.companyList[key].status = this.companyList[key].status == 1 ? '启用' : '禁用'
                }
            })
        }
    },
    mounted() {
        this.setDefaultPath('/companyInfo')

        this.getAllCompany()
    }
};
</script>

<style>
#create_company {
    position: relative;
    right: 5px;
    width: 120px;
}

#cancel_determine {
    position: absolute;
    bottom: 5px;
    right: 5px;
}
</style>